/**
 * Settings Index (Settings)
 * Card grid linking to every settings page. Designed to scale to hundreds of
 * settings without the flat tab bar the section used to use.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { SETTINGS_ITEMS } from '../../components/SettingsLayout';
import { SetupChecklistRestore } from '../../components/SetupChecklistRestore';

export function SettingsIndexPage() {
  const { user } = useAuth();
  const items = SETTINGS_ITEMS.filter((item) => !item.isVisible || item.isVisible(user));
  // Map preserves first-use order, so groups follow SETTINGS_ITEMS order; empty groups never appear.
  const groups = Array.from(
    items.reduce((acc, item) => acc.set(item.group, [...(acc.get(item.group) ?? []), item]), new Map<string, typeof items>()),
  );

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Settings</h1>

      <SetupChecklistRestore />

      {groups.map(([group, groupItems]) => (
        <section key={group} className="mb-6 sm:mb-8">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-3">{group}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            {groupItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="block rounded-lg border border-gray-200 bg-white p-4 sm:p-5 min-w-0 break-words shadow-sm transition hover:border-blue-300 hover:shadow-md"
              >
                <h3 className="text-base font-semibold text-gray-900">{item.label}</h3>
                <p className="mt-1 text-sm text-gray-500">{item.description}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </main>
  );
}
